import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@app/store";

export interface EditModeState {
  isEditMode: boolean;
  currentSheet: string | null;
}

const initialState: EditModeState = {
  isEditMode: false,
  currentSheet: null,
};

export const EDIT_MODE_SLICE_KEY = "editMode";

export const editModeSlice = createSlice({
  name: EDIT_MODE_SLICE_KEY,
  initialState,
  reducers: {
    toggleEditMode: (state) => {
      state.isEditMode = !state.isEditMode;
      if (state.currentSheet) {
        state.currentSheet = null;
      }
    },
    openBottomSheet: (state, action: PayloadAction<string>) => {
      if (state.isEditMode) {
        state.currentSheet = action.payload;
      }
    },
    closeBottomSheet: (state) => {
      state.currentSheet = null;
    },
    resetEditMode: (state) => {
      state.isEditMode = false;
      state.currentSheet = null;
    },
  },
});

export const {
  toggleEditMode,
  openBottomSheet,
  closeBottomSheet,
  resetEditMode,
} = editModeSlice.actions;

export const selectIsEditMode = (state: RootState) =>
  state[EDIT_MODE_SLICE_KEY].isEditMode;
export const selectCurrentSheet = (state: RootState) =>
  state[EDIT_MODE_SLICE_KEY].currentSheet;

export default editModeSlice.reducer;
